module.exports = __webpack_public_path__ + "img/logo_klearning.055e13a5.png";